// extracted by mini-css-extract-plugin
var _1 = "AddressList_address__3CP9j";
var _2 = "AddressList_addressMargin__CqXbL";
var _3 = "AddressList_removeAddress__KgMB2";
var _4 = "AddressList_row__UN4-d";
var _5 = "AddressList_rowAccount__GuxhO";
var _6 = "AddressList_rows__FOfAC";
export { _1 as "address", _2 as "addressMargin", _3 as "removeAddress", _4 as "row", _5 as "rowAccount", _6 as "rows" }
